import { SHOW_APP_LOADER, HIDE_APP_LOADER, TOGGLE_GUEST_UPGRADE_MODAL } from '../../actions/action_types';

const INTIAL_STATE = {
    showGuestMembershipUpgradeModal: false,
    loaderVisible: false,
}

export default (state = INTIAL_STATE, action) => {
    if (state === undefined) {
        state = null;
    }
    switch (action.type) {
        case SHOW_APP_LOADER:
            return { ...state, loaderVisible: true }
        case HIDE_APP_LOADER:
            return { ...state, loaderVisible: false }
        case TOGGLE_GUEST_UPGRADE_MODAL:
            return { ...state, showGuestMembershipUpgradeModal: action.payload }
        default:
            return state;
    }
}